// ─── Nigerian States ────────────────────────────────────
export const NIGERIAN_STATES = [
  'Abia', 'Adamawa', 'Akwa Ibom', 'Anambra', 'Bauchi', 'Bayelsa',
  'Benue', 'Borno', 'Cross River', 'Delta', 'Ebonyi', 'Edo',
  'Ekiti', 'Enugu', 'FCT', 'Gombe', 'Imo', 'Jigawa',
  'Kaduna', 'Kano', 'Katsina', 'Kebbi', 'Kogi', 'Kwara',
  'Lagos', 'Nasarawa', 'Niger', 'Ogun', 'Ondo', 'Osun',
  'Oyo', 'Plateau', 'Rivers', 'Sokoto', 'Taraba', 'Yobe', 'Zamfara',
] as const;

// ─── Deal Statuses ──────────────────────────────────────
export const DEAL_STATUSES = {
  'pending-acceptance': { label: 'Pending Acceptance', color: 'bg-accent text-accent-foreground' },
  accepted: { label: 'Accepted', color: 'bg-primary/10 text-primary' },
  'in-progress': { label: 'In Progress', color: 'bg-primary/10 text-primary' },
  'in-perfection': { label: 'In Perfection', color: 'bg-secondary text-secondary-foreground' },
  completed: { label: 'Completed', color: 'bg-primary text-primary-foreground' },
  rejected: { label: 'Rejected', color: 'bg-destructive text-destructive-foreground' },
} as const;

// ─── Matter Stage Keys ──────────────────────────────────
export const MATTER_STAGE_KEYS = [
  { key: 'deal-intake', label: 'Deal Intake & Acceptance' },
  { key: 'due-diligence', label: 'Initial Due Diligence' },
  { key: 'title-verification', label: 'Title Verification' },
  { key: 'survey', label: 'Survey & Physical Inspection' },
  { key: 'contract-drafting', label: 'Contract Drafting' },
  { key: 'negotiation', label: 'Negotiations & Amendments' },
  { key: 'governors-consent', label: "Governor's Consent Application" },
  { key: 'closing', label: 'Closing & Transfer' },
] as const;

// ─── Document Categories ────────────────────────────────
export const DOCUMENT_CATEGORIES = {
  'title-document': 'Title Document',
  survey: 'Survey',
  contract: 'Contract',
  'id-verification': 'ID Verification',
  'proof-of-address': 'Proof of Address',
  receipt: 'Receipt',
  correspondence: 'Correspondence',
  other: 'Other',
} as const;

// ─── Property Types ─────────────────────────────────────
export const PROPERTY_TYPES = {
  residential: 'Residential',
  commercial: 'Commercial',
  land: 'Land',
  'mixed-use': 'Mixed Use',
} as const;

// ─── Billing Categories ─────────────────────────────────
export const BILLING_CATEGORIES = {
  'legal-fee': 'Legal Fee',
  'stamp-duty': 'Stamp Duty',
  registration: 'Registration',
  'search-fee': 'Search Fee',
  disbursement: 'Disbursement',
  other: 'Other',
} as const;

// ─── Document Visibility ────────────────────────────────
export const DOCUMENT_VISIBILITY = {
  'lawyer-only': 'Lawyer Only',
  'lawyer-agent': 'Lawyer & Agent',
  'all-parties': 'All Parties',
} as const;

// ─── Notification Types ─────────────────────────────────
export const NOTIFICATION_TYPES = {
  deal: 'Deal',
  matter: 'Matter',
  document: 'Document',
  billing: 'Billing',
  system: 'System',
} as const;
